export default "__VITE_ASSET__CeAIfEw1__"